import ReactWordcloud from 'react-wordcloud';
import { Resizable } from "re-resizable";
import { Divider } from 'antd';
import { resizeStyle, initialSettings } from './settings'

const wordcloud = (props) => {
    return (
        <div className='container' style={{ display: (props.show && !props.isLoading) ? "flex" : "none" }}>
            <div className='border'>
                <h2>Word Cloud</h2>
                <p>The most comman words used by the viewers of the video to gain brief summary</p>
                <Divider />
                <div>
                    <Resizable defaultSize={{ width: 650, height: 350 }} style={resizeStyle}>
                        <div style={{ width: "100%", height: "100%" }}>
                            <ReactWordcloud words={props.words} options={initialSettings.wordcloud} />
                        </div>
                    </Resizable>
                </div>
            </div>
        </div>
    )
}

export default wordcloud